import Link from "next/link";

import ErrorMessage from "../ErrorMessage";

const NotAllowedError = () => {
  return (
    <ErrorMessage headline="Sorry, you don't have access to this content.">
      <span>If you think this is an error, please contact our </span>
      <Link href="https://support.newsela.com/contact/">help desk</Link>
      <span>.</span>
    </ErrorMessage>
  );
};

export default NotAllowedError;
